import { render, staticRenderFns } from "./TheModeA.vue?vue&type=template&id=a61dcc5c&scoped=true&"
import script from "./TheModeA.vue?vue&type=script&lang=js&"
export * from "./TheModeA.vue?vue&type=script&lang=js&"
import style0 from "./TheModeA.vue?vue&type=style&index=0&id=a61dcc5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61dcc5c",
  null
  
)

component.options.__file = "TheModeA.vue"
export default component.exports